import { MutableRefObject, JSX } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Modal } from '@bg-components/Modal';
import { ListIcon } from '@bg-components/Icon';
import { ModalContent } from '@bg-components/Modal/ModalContent';
import { ResultsReport } from '@bg-components/Reports/pages/ResultsReport';
import { PagesModalHeader } from '@bg-components/Modals/components/PagesModalHeader';
import { ReportSkeleton } from '@bg-components/Reports/components/ReportSkeleton/ReportSkeleton';
import { LazyRoute } from '@bg-components/LazyRoute';
import { VideoArchive } from '@bg-components/Reports/pages/VideoArchive';
import { fadeAnimation } from '@bg-components/Modals/constants/fadeAnimation';
import { IModalProps, ModalName, t } from '@bg-shared';
import { ResultsReportView } from './enums/ResultsReportView';
import classes from './ResultsModal.module.scss';

interface IProps extends IModalProps {
    openerElementRef?: MutableRefObject<HTMLElement>;
}

export const ResultsModal = (props: IProps): JSX.Element => {
    const [searchParams] = useSearchParams();
    const { view } = Object.fromEntries(searchParams);

    return (
        <Modal
            modalName={ModalName.RESULTS}
            onClose={props.onClose}
            className={classes.modal}
            animation={fadeAnimation}
            openerElementRef={props.openerElementRef}
        >
            <PagesModalHeader title={t.string('results')} icon={ListIcon} onClose={props.onClose} />
            <ModalContent>
                <LazyRoute Fallback={<ReportSkeleton filtersCount={3} />}>
                    {view === ResultsReportView.ARCHIVES ? (
                        <VideoArchive isModal />
                    ) : (
                        <ResultsReport isModal />
                    )}
                </LazyRoute>
            </ModalContent>
        </Modal>
    );
};
